<template>
    <v-card color="transparent" class="cards-group" flat tile>
        <template v-if="$vuetify.breakpoint.mdAndUp && hideNavArrows">
            <v-btn v-if="$slots['desktop-view']" icon @click="prev" class="prev-button">
                <v-icon size="45" color="dark lighten-6">chevron_left</v-icon>
            </v-btn>

            <v-window v-model="page">
                <slot name="desktop-view" />
            </v-window>

            <v-btn v-if="$slots['desktop-view']" icon @click="next" class="next-button">
                <v-icon size="45" color="dark lighten-6">chevron_right</v-icon>
            </v-btn>
        </template>

        <template v-else>
            <v-flex xs12>
                <v-window v-model="page">
                    <slot name="mobile-view" />
                </v-window>
            </v-flex>
            <v-flex xs12 class="align-center justify-center">
                <v-item-group v-model="page" class="text-xs-center" mandatory>
                    <v-item v-for="(item, index) in $slots['mobile-view']" :key="`btn-${index}`">
                        <v-btn
                            slot-scope="{ active, toggle }"
                            :input-value="active"
                            active-class="active-page-button"
                            icon
                            small
                            @click="toggle"
                            class="card-group-page-button ma-0"
                        >
                            <v-icon
                                size="12"
                                color="dark lighten-6"
                                v-text="active ? 'fiber_manual_record' : 'trip_origin'"
                            />
                        </v-btn>
                    </v-item>
                </v-item-group>
            </v-flex>
        </template>
    </v-card>
</template>

<style scoped>
.cards-group {
    position: relative;
}

.next-button,
.prev-button {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 1;
}

.next-button {
    right: -52px;
}

.prev-button {
    left: -52px;
}
.card-group-page-button {
    width: 20px !important;
    height: 20px !important;
}
.v-btn .v-btn__content .v-icon {
    color: #D4D4D4;
}
.v-item--active.v-btn .v-btn__content .v-icon {
    color: var(--v-primary-base);
    font-size: 14px !important;
}
</style>

<script>
export default {
    props: {
        hideNavArrows: Boolean,
    },
    data: () => ({
        page: 0,
        chunks: [],
    }),
    mounted() {
        this.chunks = this.$slots['desktop-view'] || [];
    },
    computed: {},
    methods: {
        next() {
            this.page = this.page + 1 === this.chunks.length ? 0 : this.page + 1;
        },
        prev() {
            this.page = this.page - 1 < 0 ? this.chunks.length - 1 : this.page - 1;
        },
    },
};
</script>
